<div mat-dialog-title>
  เอกสารการขอความยินยอม (<span [class]="statusClass">{{status}}</span>)
</div>
<mat-dialog-content class="mat-typography">
  <div>
    <label>ใช้งาน: </label>
    <span>{{ formatDate(consent.activeDatetime, 'ยังไม่ใช้งาน') }}</span>
    <ng-container *ngIf="consent.activeDatetime">
      <label> ถึง </label>
      <span>{{ formatDate(consent.expiredDatetime, 'ปัจจุบัน') }}</span>
    </ng-container>
  </div>
  <br>
  <ckeditor *ngIf="! readOnly" [(data)]="consent.docData"></ckeditor>
  <div class="consent-container" *ngIf="readOnly" [innerHTML]="consent.docData"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="statusClass === 'draft' else closeOnly">
    <ng-container *ngIf="readOnly else edittingDraft">
      หากมีการประกาศใช้งานแล้วจะไม่สามารถยกเลิกได้
      &nbsp;&nbsp;
      <button mat-raised-button (click)="backFromPreview()">ย้อนกลับ</button>
      <button mat-raised-button class="confirm-button" (click)="publish()">ประกาศ</button>
    </ng-container>
    <ng-template #edittingDraft>
      <button mat-raised-button mat-dialog-close>ยกเลิก</button>
      <button mat-raised-button class="submit-button" [mat-dialog-close]="consent" cdkFocusInitial>บันทึกร่าง</button>
      <button mat-raised-button class="confirm-button" (click)="preview()" [disabled]="!validDocData()">ตรวจสอบและประกาศ</button>
    </ng-template>
    
  </ng-container>
  <ng-template #closeOnly>
    <button mat-raised-button mat-dialog-close>ปิด</button>
  </ng-template>
</mat-dialog-actions>
